import * as adminService from '@/services/admin'

import { getMenuData } from '@/services/menu'
import { switchKey } from '@/utils/formators'

export default {
  namespaced: true,
  state: {
    menu: getMenuData,
    statistics: null,
    loading: false,
  },

  getters: {
    loading: (state) => state.loading,
    statistics: (state) => state.statistics,
  },

  mutations: {
    // statistics
    SET_STATISTICS: (state, statistics) => {
      state.statistics = statistics
    },
    UPDATE_COUNT(state, { key, count }) {
      if (count && typeof count === 'number') {
        state.menu.find((item) => item.key === key).count = count
      }
    },
    START_LOADING: (state) => {
      state.loading = true
    },
    END_LOADING: (state) => {
      state.loading = false
    },
  },
  actions: {
    // initialization
    async init({ commit, dispatch }) {
      await dispatch('fetchStatistics')
    },

    // * DATA HANDLING
    // fetch all statistics
    async fetchStatistics({ state, commit, dispatch }) {
      if (!state.statistics) {
        commit('START_LOADING')
        const statistics = await adminService.fetchStatistics()
        if (statistics) {
          commit('SET_STATISTICS', statistics)
          dispatch('updateCounts')
        }
        commit('END_LOADING')
      }
      return state.statistics
    },

    async updateCounts({ state, commit }) {
      if (state.statistics) {
        for (const [key, count] of Object.entries(state.statistics)) {
          commit('UPDATE_COUNT', { key: switchKey(key), count })
        }
      }
    },
  },
}
